// extracted by css-extract-rspack-plugin
var _1 = "C8zbq1CIEUAkTRbS";
var _2 = "IYQaM9TSvQQGtTqL";
var _3 = "C8zbq1CIEUAkTRbS";
var _4 = "IYQaM9TSvQQGtTqL";
var _5 = "FVs39cBVFU4xVAsw";
var _6 = "FVs39cBVFU4xVAsw";
var _7 = "quko2XPLaF4oAaPP";
var _8 = "Zf1qMZ60zUwTHc_q";
var _9 = "UQoJ9K5fcrIqHUdY";
export { _1 as "button-next", _2 as "button-prev", _3 as "buttonNext", _4 as "buttonPrev", _5 as "items-flat", _6 as "itemsFlat", _7 as "slide", _8 as "slider", _9 as "wrapper" }
